function getSortValue(sortField, row) {
	const parts = sortField.split('.');
	if (parts.length === 3) {
		return row.data[parts[0]][parts[1]][parts[2]];
	}
	return row.data[sortField];
}

export function compareForDynamicTable(columnKey, sortField, reverse, a, b) {
	let valA = a.columns[columnKey];
	let valB = b.columns[columnKey];

	if (sortField) {
		valA = getSortValue(sortField, a);
		valB = getSortValue(sortField, b);
	}
    if (typeof valA === 'number' && typeof valB === 'number') {
		return reverse ? valB - valA : valA - valB;
	}
	return reverse ? valB?.localeCompare(valA) : valA?.localeCompare(valB);
}
